import styled, {keyframes} from 'styled-components';
import media from '../theme/media';

const rotateIphone = keyframes `
    from, to { transform: rotate(0deg); }
    50% { transform: rotate(90deg); }
`;

const shakeIphone = keyframes `
    25% { transform: rotate(5deg) translateY(-24px); }
    35% { transform: rotate(5deg) translateY(-24px); }
    from, 15%, 20%, 30%, 40%, to { transform: rotate(0deg) translateY(0); }
`;

export const Video = styled.video`
    box-shadow: 0 1px 0 rgba(255,255,255,.6), 0 2px 40px 4px #ccced0;
    width: 100%;
    border-radius: 4px;
`;

export const VideoIpadHorizontalContainer = styled.div`
    width: fit-content;
    width: -moz-fit-content;
    border-radius: 28px;
    border: 18px solid #1e1f21;
    box-shadow: 0 10px 10px rgba(0,0,0,0.1);
    position: relative;
    z-index: 99;
    ${media.phone`
        border-radius: 20px;
        border: 6px solid #1e1f21;
    `}
    
    video, img {
      border-radius: 28px;
      display: block;
      ${media.phone`
          border-radius: 14px;
      `}
    }
`;

export const VideoIphoneHorizontalContainer = styled.div`
    width: fit-content;
    width: -moz-fit-content;
    border: 12px solid #1e1f21;
    border-radius: 40px;
    box-shadow: 0 10px 10px rgba(0,0,0,0.1);
    position: relative;
    z-index: 99;
    ${media.phone`
        border-radius: 20px;
        border: 6px solid #1e1f21;
    `}
    
    &.shake {
      animation: ${shakeIphone} 4.025s infinite;
      transform-origin: 80% 50%;
    }
    
    &.rotate {
      animation: ${rotateIphone} 6s infinite;
    }
    
    video, img {
      border-radius: 28px;
      display: block;
      ${media.phone`
          border-radius: 14px;
      `}
    }
    
    .notch {
      position: absolute;
      top: 50%;
      left: 0;
      height: calc((280/375) * 100%);
      width: calc((42 / 812) * 100%);
      background-color: #1e1f21;
      border-radius: 0 28px 28px 0;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateY(-50%);
      ${media.phone`
          border-radius: 0 14px 14px 0;
      `}
`;

export const VideoIphoneVerticalContainer = styled.div`
    width: 100%;
    height: auto;
    max-width: 375px;
    border-right: 12px solid #1e1f21;
    border-radius: 24px;
    border-left: 12px solid #1e1f21;
    border-top: 56px solid #1e1f21;
    border-bottom: 56px solid #1e1f21;
    box-shadow: 0 10px 10px rgba(0,0,0,0.1);
    margin-bottom: 4rem;
    img {
      display: block;
    }
`;

export const VideoIphone = styled.video`
    width: 100%;
    height: auto;
    display: block;
`;

export const VideoIpad = styled.video`
    width: 720px;
    position: absolute;
    top: 106px;
    left: 68px;
    
    ${media.tablet`
        width: 100%;
        position: static;
        border: 16px solid black;
        border-radius: 16px;
    `}
    ${media.phone`
        border: 12px solid black;
        border-radius: 12px;
    `}
    ${media.tiny`
        border: 8px solid black;
        border-radius: 8px;
    `}
`;

export const VideoIpadOverlay = styled.img`
  position: absolute;
  left: 0;
  top: 5rem;
  z-index: 3;
  
  ${media.tablet`
    display: none;
  `}
`;

export const VideoIpadBackground = styled.img`
  ${media.tablet`
    display: none;
  `}
`;

export const VideoIphoneOverlay = styled.img`
  position: absolute;
  left: 0;
  ${media.tablet`
    display: none;
  `}
`


// WEBPACK FOOTER //
// src/theme/video.js